<template>
  <b-form-group
    label="Metin"
    label-for="text"
  >
    <b-form-textarea
      id="text"
      v-model="itemData.text"
      placeholder="Metin"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormTextarea } from 'bootstrap-vue'

export default {
  name: 'TitleText',
  components: { BFormTextarea, BFormGroup },
  computed: {
    itemData() {
      return this.$store.getters['carousel/dataItem']
    },
  },
}
</script>
